import { useEffect, useState } from 'react'
import { Box, Image, Spinner, Flex } from '@chakra-ui/react'

const images = [
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginvendas-copy.png1738267935.7843',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginvendas.png1738267935.7102',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginproducao-2.png1738267935.5874',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginproducao.png1738267935.4762',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginlogistica-copy.png1738267935.3165',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginlogistica.png1738267935.2193',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginfinanceiro.png1738267935.0077',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginfinanceiro-2.png1738267935.1222',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginadministrativo--2.png1738267934.9031',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginadministrativo.png1738267934.7305',
  'https://imgproductioncrm.s3.us-east-2.amazonaws.com/artes-loginvendas.png1738262627.6979',
]

export const RandomImageBox = () => {
  const [imageSrc, setImageSrc] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Escolher uma imagem aleatória ao carregar o componente
    const randomImage = images[Math.floor(Math.random() * images.length)]
    setImageSrc(randomImage)
  }, [])

  const handleImageLoad = () => {
    setIsLoading(false)
  }

  return (
    <Box maxW="100%" w="100%" border="1px solid #cfcfcf" h="100%" position="relative" boxShadow="0px 3px 6px rgba(43, 43, 43, 0.14)">
      {isLoading && (
        <Flex position="absolute" top="0" left="0" right="0" bottom="0" justifyContent="center" alignItems="center" bg="gray.50" zIndex="1">
          <Spinner size="xl" color="gray.500" thickness="4px" />
        </Flex>
      )}
      <Image
        src={imageSrc}
        alt="Imagem de fundo"
        w="100%"
        h="auto"
        objectFit="cover"
        display={isLoading ? 'none' : 'block'}
        onLoad={handleImageLoad}
        onError={handleImageLoad}
      />
    </Box>
  )
}
